module.exports = __webpack_public_path__ + "static/media/edit.c0692ed5.svg";